import { Button, Header, Image, Table } from 'semantic-ui-react';

function AssignAssetDetails({
  assetDetails: {
    name,
    image,
    receiver,
    currentTask,
    currentSubtask,
    workflowStatus,
    receiverStatus,
    handovertype,
  },
  handoverHandler,
}: {
  assetDetails: {
    name: string;
    image: string;
    receiver: string;
    currentTask: string;
    currentSubtask: string;
    workflowStatus: string;
    receiverStatus: string;
    handovertype: string;
  };
  handoverHandler: () => void;
}) {
  return (
    <div className="assign-asset-scan-wrapper">
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <Header as="h2">
          <Header.Content style={{ fontWeight: 700 }}>
            Asset Details
          </Header.Content>
        </Header>
        <Image
          style={{
            margin: '10px auto 20px auto',
            width: '120px',
            height: '120px',
          }}
          src={image || '/assets/user.png'}
          size="tiny"
          circular
        />
        <Button primary color="teal" onClick={handoverHandler}>
          {handovertype}
        </Button>
      </div>
      <Table definition>
        <Table.Body>
          <Table.Row>
            <Table.Cell width={7}>
              <strong>Title</strong>
            </Table.Cell>
            <Table.Cell>{name}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={7}>
              <strong>Receiver</strong>
            </Table.Cell>
            <Table.Cell>{receiver}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={7}>
              <strong>Current Task</strong>
            </Table.Cell>
            <Table.Cell>{currentTask}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={7}>
              <strong>Current SubTask</strong>
            </Table.Cell>
            <Table.Cell>{currentSubtask}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={7}>
              <strong>Workflow Status</strong>
            </Table.Cell>
            <Table.Cell>{workflowStatus}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={7}>
              <strong>Receiver Status</strong>
            </Table.Cell>
            <Table.Cell>{receiverStatus}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
}

export default AssignAssetDetails;
